<template>
  <a-card :bordered="false">
    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('敏感内容日志.用户ID')">
              <a-input v-model="queryParam.userId" @pressEnter="handleQuery" allow-clear placeholder="请输入用户ID" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('敏感内容日志.用户信息')">
              <a-input v-model="queryParam.nickName" @pressEnter="handleQuery" allow-clear :placeholder="$t('敏感内容日志.用户信息搜索提示')" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('敏感内容日志.用户IP')">
              <a-input v-model="queryParam.ip" @pressEnter="handleQuery" allow-clear placeholder="请输入用户IP" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('敏感内容日志.命中类型')">
              <a-select v-model="queryParam.hitType" allowClear @change="handleQuery">
                <a-select-option value="1">{{ $t('敏感内容日志.文本') }}</a-select-option>
                <a-select-option value="2">{{ $t('敏感内容日志.图片') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('敏感内容日志.业务场景')">
              <a-input v-model="queryParam.bizType" @pressEnter="handleQuery" allow-clear placeholder="如 nickName/avatar" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('敏感内容日志.创建时间')">
              <a-range-picker v-model="createTime" @change="onChangeCreateTime" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              <a-button style="margin-left: 8px" type="primary" ghost @click="handleExport" v-hasPermi="['user:sensitiveLog:export']">
                <a-icon type="download" />{{$t('通用.按钮.导出')}}
              </a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 数据表格 -->
    <a-table
      :loading="loading"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      @change="handleTableChange"
      :bordered="tableBordered"
    >
      <span slot="userInfo" slot-scope="text, record">
        {{ $t('敏感内容日志.昵称') }}：{{ record.nickName || '-' }} <br/>
        {{ $t('敏感内容日志.手机号') }}：{{ record.mobile || '-' }}
      </span>
      <span slot="hitType" slot-scope="text, record">
        <a-tag :color="record.hitType === 1 ? 'orange' : 'red'">
          {{ record.hitType === 1 ? $t('敏感内容日志.文本') : $t('敏感内容日志.图片') }}
        </a-tag>
      </span>
      <span slot="content" slot-scope="text, record">
        <span v-if="record.hitType === 2">
          <a v-if="record.imageUrl" @click="handleImagePreview(record.imageUrl)">{{ $t('敏感内容日志.查看违规图片') }}</a>
          <span v-else>-</span>
        </span>
        <span v-else :title="record.content">{{ record.content || '-' }}</span>
      </span>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDetail(record)" v-hasPermi="['user:sensitiveLog:query']">
          <a-icon type="eye" />{{$t('通用.按钮.详情')}}
        </a>
      </span>
    </a-table>

    <!-- 详情弹窗 -->
    <detail-form ref="detailForm" />
  </a-card>
</template>

<script>
import { pageSensitiveLog, exportSensitiveLog } from '@/api/user/sensitiveLog'
import { tableMixin } from '@/store/table-mixin'
import DetailForm from './modules/DetailForm'

export default {
  name: 'UserSensitiveLog',
  components: { DetailForm },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      createTime: [],
      queryParam: {
        userId: undefined,
        nickName: undefined,
        ip: undefined,
        hitType: undefined,
        bizType: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => this.$t('通用.文本.共') + ` ${total} ` + this.$t('通用.文本.条')
      },
      columns: [
        { title: this.$t('敏感内容日志.用户信息'), dataIndex: 'userInfo', scopedSlots: { customRender: 'userInfo' }, width: 180 },
        { title: this.$t('敏感内容日志.用户ID'), dataIndex: 'userId' },
        { title: this.$t('敏感内容日志.用户IP'), dataIndex: 'ip' },
        { title: this.$t('敏感内容日志.业务场景'), dataIndex: 'bizType' },
        { title: this.$t('敏感内容日志.命中类型'), dataIndex: 'hitType', scopedSlots: { customRender: 'hitType' } },
        { title: this.$t('敏感内容日志.敏感内容'), dataIndex: 'content', scopedSlots: { customRender: 'content' }, ellipsis: true },
        { title: this.$t('敏感内容日志.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' } },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 100 }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      pageSensitiveLog(this.queryParam).then(response => {
        this.list = response.data.records
        this.pagination.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.pagination.current = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        userId: undefined,
        nickName: undefined,
        ip: undefined,
        hitType: undefined,
        bizType: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.createTime = []
      this.pagination.current = 1
      this.handleQuery()
    },
    onChangeCreateTime(dates, dateStrings) {
      this.queryParam.createBeginTime = dateStrings[0] ? dateStrings[0] + ' 00:00:00' : undefined
      this.queryParam.createEndTime = dateStrings[1] ? dateStrings[1] + ' 23:59:59' : undefined
    },
    handleTableChange(pagination) {
      this.queryParam.pageNum = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    handleDetail(row) {
      this.$refs.detailForm.show(row.id)
    },
    handleImagePreview(url) {
      this.$info({
        title: this.$t('敏感内容日志.图片预览'),
        content: (h) => h('img', { attrs: { src: url, style: 'max-width: 100%; max-height: 400px;' } }),
        width: 600,
        okText: this.$t('通用.按钮.关闭')
      })
    },
    handleExport() {
      exportSensitiveLog(this.queryParam).then(response => {
        this.download(response)
      })
    }
  }
}
</script>
